import { useEffect, useState} from "react";
import {base64DecodeUnicode, toastSuccess} from "../../../assets/functions";
import Loading from "../../../component/Loading/Loading";
import {getManagerHeader} from "../../Login/functions";
import axios from "axios";
import {baseCmsApiUrl} from "../../../assets/Constants";
import {useNavigate, useParams} from "react-router-dom";
import ManagerForm from "../component/ManagerForm/ManagerForm";
import {getManagerById} from "../functions";

const AddManager = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const staticLogin = {
        username: "",
        password: "",
    };
    const address = {
        townId: "1",
        address: "",
        picture: "",
        location : {
            lat : "",
            lng : ""
        }
    };
    const person = {
        firstname: "",
        lastname: "",
        profile: "",
        sex: "MALE",
        phonenumbers: [],
        activePhonenumber: "",
        nickname: "",
        birthday: Math.round(+new Date() / 1000),
        addresses: [{...address}],
        staticLogin: {...staticLogin},
    }
    const exceptionGood = {
        includeProduct: [],
        excludeProduct: [],
        includeCategory: [],
        excludeCategory: [],
        includeBrand: [],
        excludeBrand: [],
    };

    const [manager, setManager] = useState({
        person: {...person},
        accessibility: "MANAGER",
        exceptionGood: {...exceptionGood}
    });



    useEffect(() => {
        (async () => {
            document.title = "ویرایش مدیر" ;
            const manager = await getManagerById(id);
            console.log(manager)
            setManager(manager)
            setIsLoading(false);
        })();

    }, []);

    const handleSubmit = async () => {
        setIsLoading(true);
        const headers = getManagerHeader();
        axios.put(baseCmsApiUrl + 'managers', manager, {headers})
            .then((response) => {
                toastSuccess(base64DecodeUnicode(response.statusText));
                navigate("/managers");
                return;
            })
            .catch((e) => {
                console.error(e)
                console.log(base64DecodeUnicode(e.response.statusText))
                console.log(e.response.data)
            }).finally(() => {
            setIsLoading(false)
        })
    }

    if (isLoading)
        return <Loading/>

    return (
        <div className="container-fluid p-0">
            <div className="mb-4">
                <h1 className="h3 d-inline align-middle">ویرایش مدیر</h1>
            </div>

            <ManagerForm manager={manager} onChange={(value) => {
                console.log(value);
                setManager(value);
            }} />


            <button className={"btn btn-secondary btn-lg w-100"} onClick={handleSubmit} disabled={isLoading}>ویرایش
                مدیر
            </button>
        </div>
    )
}

export default AddManager;